<template>
  <banner-page title="תווי קנייה ברשת רמי לוי"
               :background-position="banner.backgroundPosition"
               :background-color="banner.backgroundColor"
               :imgSrc="require('@/assets/super-discount/rami/discount.svg')">
    <div v-if="accounts.length > 0" class="padding-m">
      <div class="ri-large-headline">מאיזה חשבון בנק לקנות את התווים?</div>
      <separator />
      <div v-for="(account, i) of accounts" :key="i" style="height: 90px" class="flex-column full-height full-width space-between">
        <div class="flex-row align-center full-width full-height space-between">
          <img :src="require(`@/assets/bank-logos/${account.logoFile}`)" style="max-width: 100px">
          <div class="flex-column margin-horizontal-s" style="width: 200px">
            <div class="ri-bold-body account-name">{{account.credsName}}</div>
            <div v-if="account.hasCurrentBalance" class="ri-label balance-amount">
              יתרה: {{ account.balance | signedFormatAmountWithFraction(0) | shekel}}
            </div>
          </div>
          <label class="radio-item">
            <input class="radio-button" type="radio" id="select-bank" :value="account" v-model="selectedBank" />
            <span class="custom-radio">
              <icon class="radio-icon" icon-name="check" :color="icon.color" weight="bold" variant="rounded" size="18px" fill />
            </span>
          </label>
        </div>
        <separator/>
      </div>
      <riseup-button class="margin-top-m" :action="purchase" title="סיימתי, אפשר להמשיך" :disabled="!selectedBank" :loading="loading"/>
    </div>
    <div v-else  class="padding-m">
      <div class="ri-bold-body">ניתן לרכוש תווים רק באמצעות חשבונות שמחוברים בבנקאות פתוחה.</div>
      <riseup-button class="margin-top-m" :action="goToCredsScreen" title="להוספת חשבון" />
    </div>
  </banner-page>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import Segment from '@/Segment';
import { mapActions, mapGetters, mapState } from 'vuex';
import _ from 'lodash';
import BillyApi from '@/api/BillyApi';
import router from '@/router';
import RamiLeviPurchasePopup from './RamiLeviPurchasePopup.vue';
import balance from '../../../../../store/modules/balance';

export default {
  name: 'RamiLeviPurchasePage',
  components: {
    BannerPage: BaseUI.Pages.BannerPage,
    Separator: BaseUI.Separator,
    RiseupButton: BaseUI.RiseupButton,
    Icon: BaseUI.Icon,
  },
  data() {
    return {
      selectedBank: undefined,
      loading: false,
      banner: {
        backgroundPosition: BaseUI.LayoutConsts.BACKGROUND_POSITION.BOTTOM_LEFT,
        backgroundColor: BaseUI.LayoutConsts.COLOR_VARIANT.GREEN,
      },
      icon: {
        color: BaseUI.Colors.riseupWhite,
      },
    };
  },

  async created() {
    Segment.trackUserGot('RamiLevi_SuperDiscount_SelectBank_Entered');
    await this.initBalance();
  },
  computed: {
    balance() {
      return balance;
    },
    ...mapGetters('credentials', ['connectedBankCredentials']),
    ...mapState('balance', ['balances']),
    accounts() {
      const obkCreds = this.connectedBankCredentials.filter(item => item.provider === 'aggregator');
      return _.flatMap(obkCreds, credentials => _.chain(credentials.accounts)
        .filter(account => account.sourceType === 'bank')
        .reject(account => account.isExcluded)
        .map(account => {
          const accountBalance = _.find(this.balances, balance => balance.accountNumberPiiId === account.accountNumberPiiId);
          return {
            ...account,
            credsName: credentials.name,
            logoFile: credentials.logoFile,
            credentialsId: credentials.credentialsId,
            hasCurrentBalance: !_.isNil(accountBalance),
            balance: accountBalance ? accountBalance.balance : 'NaN', // FIXME: what should we do here?
          };
        })
        .value());
    },
  },
  methods: {
    ...mapActions('balance', ['initBalance']),
    ...mapActions('modalRootStore', ['openModal']),

    async goToCredsScreen() {
      Segment.trackUserInteraction('RamiLevi_SuperDiscount_GoToCredsScreen_Clicked');
      await router.push({ name: 'CredentialsSettings' });
    },
    async purchase() {
      this.loading = true;
      Segment.trackUserInteraction('RamiLevi_SuperDiscount_SelectBank_Next_Clicked');
      const result = await BillyApi.claimVoucher('RAMI_LEVI', 500, this.selectedBank.credentialsId, this.selectedBank.ibanPiiId);
      if (result.status === 'SUCCESS') {
        Segment.trackUserGot('RamiLevi_SuperDiscount_SelectBank_Success',
          { bank: this.selectedBank.source, balance: this.selectedBank.accountBalance });
        await this.openModal({
          component: RamiLeviPurchasePopup,
          popupAlignment: 'center',
          props: {
            redirectUrl: result.redirectUrl,
          },
        });
      } else {
        Segment.trackUserGot('RamiLevi_SuperDiscount_SelectBank_ClaimVoucherFailed',
          { bank: this.selectedBank.source, balance: this.selectedBank.accountBalance });
        await router.push({ name: 'PurchaseErrorPage' });
      }
    },

  },
};
</script>

<style lang="scss" scoped>
@import "~@riseupil/base-ui/src/scss/riseup-colors";
@import "~@riseupil/base-ui/src/scss/spacings";

.balance-amount {
  color: $riseup_gray_3;
}

.account-name {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.radio-item:not(:last-child){
  margin-bottom: $ri-spacing-s;
}

.radio-item {
  width: 25px;
  height: 25px;
}

/* Hide the default radio button */
input[type="radio"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

/* Custom radio button styles */
.custom-radio {
  display: inline-block;
  height: 25px;
  width: 25px;
  min-width: 25px;
  min-height: 25px;
  border-radius: 50%;
  border: 3px solid $riseup_blue; /* Blue border for both states */
  position: relative;
  cursor: pointer;
}

.radio-item .radio-icon {
  display: none; /* Hide when unchecked */
}

/* Style for when the radio button is checked */
input[type="radio"]:checked + .custom-radio {
  background-color: $riseup_blue;
}

input[type="radio"]:checked + .custom-radio .radio-icon {
  display: block; /* Show when checked */
}

</style>
